/**
 * «گزارش‌ها ← گزارش‌های دوره‌ای» (since 60.11.483; before, a tab of «تنظیمات کسب‌وکار»). Every link to the
 * periodic reports and their runs is built here; the old settings addresses, which stored notifications and
 * SMS links still carry, are sent here by «تنظیمات کسب‌وکار» (movedPeriodicReportsPath).
 */
export const PERIODIC_REPORTS_ROOT = '/reports/periodic'

/** The `?companyId=` of the page: the business whose reports it shows; 0 when absent or not a real id. */
export const COMPANY_PARAMETER = 'companyId'

export const readPeriodicReportsCompany = (params: URLSearchParams): number => {
  const id = Number((params.get(COMPANY_PARAMETER) || '').trim())
  return Number.isSafeInteger(id) && id > 0 ? id : 0
}

/**
 * The periodic reports of a business; `newSchedule` opens the editor of a new schedule, prefilled with `filter`
 * (the invoice list's `filter_*` query string) when one is given.
 */
export const periodicReportsPath = (
  companyId: number,
  options: {newSchedule?: boolean; filter?: string} = {}
): string => {
  const query = new URLSearchParams()
  if (companyId > 0) query.set(COMPANY_PARAMETER, String(companyId))
  if (options.newSchedule) query.set('new', '1')
  if (options.newSchedule && options.filter) query.set('filter', options.filter)
  const text = query.toString()
  return text ? `${PERIODIC_REPORTS_ROOT}?${text}` : PERIODIC_REPORTS_ROOT
}

/** The full report of one run; the run itself names its business. */
export const periodicReportRunPath = (token: string): string =>
  `${PERIODIC_REPORTS_ROOT}/runs/${encodeURIComponent(token)}`

/**
 * An old «تنظیمات کسب‌وکار ← گزارش دوره‌ای» address (`?new=1&filter=…` included) as the new page's address.
 */
export const movedPeriodicReportsPath = (companyId: number, search: string): string => {
  const old = new URLSearchParams(search)
  return periodicReportsPath(companyId, {
    newSchedule: old.get('new') === '1',
    filter: old.get('filter') || undefined,
  })
}
